import { isUndefined } from 'libraries/lodash'

const hasSideWidth = ({
  pageView,
  _pageView,
  deviceType: { isLargeDesktop },
  browser,
  left
}) => {
  const hasLeft = !isUndefined(left)
  const sideWidth = (
    (pageView === 'left' && (_pageView === 'main' && browser.name === 'ie')) ||
    (browser.name === 'ie' && isLargeDesktop && hasLeft)
  )

  return sideWidth
}

export default hasSideWidth
